import {differenceInMinutes, format, intervalToDuration, isSameDay} from 'date-fns';
import {Meeting, formatDuration} from '../../data';
import {TranslationService} from '../../@types/i18next';

export const getFormatedMeetingTime = (meeting: Meeting, t: TranslationService) => {
  const startTime = new Date(meeting.startDateTime);
  const endTime = new Date(meeting.endDateTime);
  const singleDay = isSameDay(startTime, endTime);

  const labelFormat = singleDay ? 'HH:mm' : 'dd-MM HH:mm';

  const timeLabel = meeting.isAllDay
    ? t('meeting:AllDay')
    : `${format(startTime, labelFormat)} – ${format(endTime, labelFormat)}`;

  return timeLabel;
};

export const getFormatedLastUpdateTime = (lastLoadedTime: Date, currentDate: Date, t: TranslationService) => {
  const lastUpdatedAgo = intervalToDuration({start: lastLoadedTime, end: currentDate});
  const isUpdatedLessThanMinuteAgo = lastLoadedTime ? differenceInMinutes(currentDate, lastLoadedTime) < 1 : undefined;

  const formattedDuration = formatDuration(t, lastUpdatedAgo);

  return isUpdatedLessThanMinuteAgo
    ? t('meeting:UpdatedJustNow')
    : t('meeting:UpdatedAgo', {
        countWithMinutesSuffix: formattedDuration,
      });
};
